module.exports = __webpack_public_path__ + "static/media/Handbok Dysmate-Y SE version 1.0_compressed.a07d96aa.pdf";